import { render, staticRenderFns } from "./create-investment-round.vue?vue&type=template&id=54db78b4&scoped=true"
import script from "./create-investment-round.vue?vue&type=script&lang=js"
export * from "./create-investment-round.vue?vue&type=script&lang=js"
import style0 from "./create-investment-round.vue?vue&type=style&index=0&id=54db78b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db78b4",
  null
  
)

export default component.exports